import { styled } from '@linaria/react';
import { fonts, layout, semantic, space, textStyle } from '../../theme/tokens';

export const Heading = styled.h1<{ $flush?: boolean }>`
  font-family: ${textStyle.display['size-md'].fontFamily};
  font-size: ${textStyle.display['size-md'].fontSize};
  font-weight: ${textStyle.display['size-md'].fontWeight};
  line-height: ${textStyle.display['size-md'].lineHeight};
  letter-spacing: ${textStyle.display['size-md'].letterSpacing};
  color: ${semantic.text.primary};
  text-align: left;
  margin: 0 0 ${({ $flush }) => ($flush ? '0' : space['space-1000'])};
  max-width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    max-width: ${({ $flush }) => ($flush ? '100%' : '75%')};
  }
`;

export const Subtitle = styled.span`
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.tertiary};
`;
